// 采购管理-销售已完成
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">销售已完成</span>
                    </div>
                    <div class="search-content mar_b" style="margin-top:-15px;margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-col :span="13">
                            <el-form-item prop="shape" label="形状：" label-width="60px">
                                <el-checkbox-group v-model="checkboxGroup1" size="small" @change="checkboxChange1">
                                    <el-tooltip class="item" effect="light" content="圆形" placement="top-start">
                                        <el-checkbox-button label="圆形"><span class="el-icon-round"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="公主方" placement="top-start">
                                        <el-checkbox-button label="公主方"><span class="el-icon-princess"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="雷迪恩" placement="top-start">
                                        <el-checkbox-button label="雷迪恩"><span class="el-icon-radiant"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="阿斯切" placement="top-start">
                                        <el-checkbox-button label="阿斯切"><span class="el-icon-asscher"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="马眼" placement="top-start">
                                        <el-checkbox-button label="马眼"><span class="el-icon-marquise"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="椭圆形" placement="top-start">
                                        <el-checkbox-button label="椭圆形"><span class="el-icon-oval"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="祖母绿" placement="top-start">
                                        <el-checkbox-button label="祖母绿"><span class="el-icon-emerald"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="梨形" placement="top-start">
                                        <el-checkbox-button label="梨形"><span class="el-icon-pear1"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="心形" placement="top-start">
                                        <el-checkbox-button label="心形"><span class="el-icon-heart"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="垫形" placement="top-start">
                                        <el-checkbox-button label="垫形"><span class="el-icon-cushion"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="其他" placement="top-start">
                                        <el-checkbox-button label="其他"><span class="el-icon-others"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="三角形" placement="top-start">
                                        <el-checkbox-button label="三角形"><span class="el-icon-triangle"/></el-checkbox-button>
                                    </el-tooltip>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="col" label="颜色：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup2" size="small" @change="checkboxChange2">
                                    <el-checkbox-button v-for="color in colorlist" :label="color" :key="color">{{color}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="cla" label="净度：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup3" size="small" @change="checkboxChange3">
                                    <el-checkbox-button v-for="cla in clalist" :label="cla" :key="cla">{{cla}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="cut" label="切工：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup4" size="small" @change="checkboxChange4">
                                    <el-checkbox-button v-for="cut in cutlist" :label="cut" :key="cut">{{cut}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="3EX" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="select3exn" size="small">3EX-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="pol" label="抛光：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup5" size="small" @change="checkboxChange5">
                                    <el-checkbox-button v-for="pol in pollist" :label="pol" :key="pol">{{pol}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="3VG" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="select3vgn" size="small">3VG-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="sym" label="对称：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup6" size="small" @change="checkboxChange6">
                                    <el-checkbox-button v-for="sym in pollist" :label="sym" :key="sym">{{sym}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="3GD" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="select3gdn" size="small">3GD-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="fl" label="荧光：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup7" size="small" @change="checkboxChange7">
                                    <el-checkbox-button v-for="fl in fllist" :label="fl" :key="fl">{{fl}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <!--
                            <el-form-item prop="cert" label="证书：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup8" size="small" @change="checkboxChange8">
                                    <el-checkbox-button v-for="cert in certlist" :label="cert" :key="cert">{{cert}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            -->
                            <el-form-item class="search-but" style="float:right;margin-top:-15px;margin-right:120px">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item>
                            </br>
                            <!--
                            <el-form-item prop="rate" label="汇率：" label-width="90px" style="margin-top:-15px">
                                {{ ratevalue }}
                            </el-form-item>
                            
                            <el-form-item prop="rate" label="" label-width="90px" style="margin-top:-15px">
                                <el-button type="primary" @click="dialogTableVisible11 = true" size="small">调整汇率</el-button>
                            </el-form-item>
                            -->
                        </el-col>
                        <el-col :span="11">
                            <el-form-item prop="ct" label="重量：" label-width="90px">
                                <el-select v-model="query.ct" placeholder="请选择重量" clearable
                                        @blur="ctSelect" @change="ctChange" filterable allow-create style="width:180px">
                                        <el-option label="0.30-0.39" value="3"></el-option>
                                        <el-option label="0.40-0.49" value="4"></el-option>
                                        <el-option label="0.50-0.59" value="5"></el-option>
                                        <el-option label="0.60-0.69" value="6"></el-option>
                                        <el-option label="0.70-0.79" value="7"></el-option>
                                        <el-option label="0.80-0.89" value="8"></el-option>
                                        <el-option label="0.90-0.99" value="9"></el-option>
                                        <el-option label="1.00-1.09" value="10"></el-option>
                                        <el-option label="1.10-1.49" value="11"></el-option>
                                        <el-option label="1.50-1.99" value="12"></el-option>
                                        <el-option label="2.00-2.99" value="13"></el-option>
                                        <el-option label="3.00-3.99" value="14"></el-option>
                                        <el-option label="4.00-4.99" value="15"></el-option>
                                        <el-option label="5.00-10.00" value="16"></el-option>
                                </el-select>
                                <el-input v-model="query.ct3" placeholder="请输入" style="width:80px" @change="ctChange3"></el-input>
                                -<el-input v-model="query.ct4" placeholder="请输入" style="width:80px" @change="ctChange4"></el-input>
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="ct" label="" label-width="80px">
                                <el-input v-model="query.ct2" placeholder="请输入"></el-input>
                            </el-form-item>-->
                            <el-form-item prop="cert_no" label="证书号：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.cert_no" placeholder="请输入" style="width:180px"></el-input>
                            </el-form-item>
                            <!--
                            <el-form-item prop="stock_id" label="货号：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.stock_id" placeholder="请输入" style="width:180px"></el-input>
                            </el-form-item>
                            -->
                            <br>
                            <el-form-item prop="place" label="地点：" label-width="90px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup12" size="small" @change="checkboxChange12">
                                    <el-checkbox-button v-for="item in placeList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                                <!--
                                <el-select v-model="query.place" placeholder="请选择" clearable style="width:220px">
                                    <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                                -->
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="ispay" label="是否付款：" label-width="90px" style="margin-top:-15px">
                                <el-select v-model="query.ispay" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="已付款" value="1"></el-option>
                                    <el-option label="未付款" value="2"></el-option>
                                </el-select>
                            </el-form-item><br>-->
                            <!--
                            <el-form-item prop="sale_status" label="钻石状态：" label-width="90px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup9" size="small" @change="checkboxChange9">
                                    <el-checkbox-button v-for="item in sale_statusList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <br>
                            -->
                            <!--
                            <el-form-item prop="inv_status" label="库存状态：" label-width="90px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup11" size="small" @change="checkboxChange11">
                                    <el-checkbox-button v-for="item in inv_statusList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            -->
                            
                            <el-form-item prop="buy_date" label="采购日期：" label-width="90px" style="margin-top:-15px">
                                <el-date-picker v-model="query.buy_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <el-form-item prop="deal_date" label="出库日期：" label-width="90px" style="margin-top:-15px">
                                <el-date-picker v-model="query.deal_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <el-form-item prop="supplier" label="供应商：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.supplier" placeholder="请输入" style="width:150px"></el-input>
                            </el-form-item>
                            <el-form-item prop="remark" label="备注：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.remark" placeholder="请输入" style="width:150px"></el-input>
                            </el-form-item><br>
                            <el-form-item prop="max_meas" label="最大直径：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.max_meas1" placeholder="请输入" style="width:80px"></el-input>
                                -<el-input v-model="query.max_meas2" placeholder="请输入" style="width:80px"></el-input>
                            </el-form-item>
                            <el-form-item prop="min_meas" label="最小直径：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.min_meas1" placeholder="请输入" style="width:80px"></el-input>
                                -<el-input v-model="query.min_meas2" placeholder="请输入" style="width:80px"></el-input>
                            </el-form-item>
                            <el-form-item prop="lirunlv" label="利润率：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.lirunlv1" placeholder="请输入" style="width:80px"></el-input>
                                -<el-input v-model="query.lirunlv2" placeholder="请输入" style="width:80px"></el-input>
                            </el-form-item>
                            </el-col>
                        </el-form>
                    </div>
                    <!--
                    <div class="search-content mar_b" style="margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-form-item prop="cert_no" label="证书号：" label-width="100px">
                                <el-input v-model="query.cert_no" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="deal_date" label="完成日期：" label-width="100px">
                                <el-date-picker v-model="query.deal_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            
                            <el-form-item prop="account_date" label="记账日期：" label-width="100px">
                                <el-date-picker v-model="query.account_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <el-form-item prop="clients" label="客户名称：" label-width="100px">
                                <el-input v-model="query.clients" placeholder="请输入"></el-input>
                            </el-form-item>
                            
                            <el-form-item class="search-but" style="float:right;margin-right:200px">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>-->
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">获取证书号</el-button>
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="exportAll" size="small">导出全部</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <!--分页-->
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'>已选：{{data_len}}；克重：{{ ct_total }}实收{{ sale_price_total }}；成本：￥{{ cost_total }}；利润：￥{{ income_total }}；利润率：{{ profit_rate_total }}%</span>
                        </div>
                        <br>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[50, 100, 200, 500, 1000]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                    <div class="text e-info auto-table">
                        <el-table :data="diamondInfoList" stripe
                            @selection-change="selectionLineChangeHandle" @sort-change="sortTableFun" height='600px'
                            ref="refTable"
                            :header-cell-style="{background:'#eef1f6',color:'black',fontSize:'12px',padding:'0',margin:'0'}" 
                            :row-style="{height:'10px',color:'black',fontSize:'11px',padding:'0 0',margin:'0'}">
                            <el-table-column type="selection" align="center" width="40"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="cert_no" label="证书号"></el-table-column>
                            <!--<el-table-column align="center" min-width="8%" prop="sale_status" label="状态"></el-table-column>-->
                            <el-table-column align="center" min-width="10%" prop="buy_date" label="采购日期"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="deal_date" label="完成日期" :formatter="formatterDate"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="place" label="地点"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="supplier" label="供应商"></el-table-column>
                            <el-table-column align="center" min-width="13%" prop="canshu" label="参数">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.ct }}ct</span>
                                    <span>{{ scope.row.shape }}</span>
                                    <span>{{ scope.row.col }}</span>
                                    <span>{{ scope.row.cla }}</span>
                                    <br>
                                    <span>{{ scope.row.cut }}</span>
                                    <span>{{ scope.row.pol }}</span>
                                    <span>{{ scope.row.sym }}</span>
                                    <span>{{ scope.row.fl }}</span>
                                </template>
                            </el-table-column>
                            <!--
                            <el-table-column align="center" min-width="8%" prop="shape" label="形状"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="ct" label="重量" :render-header="renderHeader" sortable></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="col" label="颜色"></el-table-column>
                            <el-table-column align="center" min-width="7%" prop="cla" label="净度"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="cut" label="切工"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="pol" label="抛光"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="sym" label="对称"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="fl" label="荧光"></el-table-column>
                            -->
                            <el-table-column align="center" min-width="9%" prop="cost_rap" label="成本rap"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="cost_dis" label="成本折扣"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="cost" label="货品成本"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="point" label="综合费点"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="usd_cost" label="USD成本"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="rmb_cost" label="RMB成本"></el-table-column>

                            <el-table-column align="center" min-width="9%" prop="sale_rap" label="销售rap"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="new_dis" label="销售折扣"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="sale_usd" label="销售美金"></el-table-column>
                            <!--
                            <el-table-column align="center" min-width="8%" prop="sale_rate" label="销售汇率"></el-table-column>
                            -->
                            <el-table-column align="center" min-width="8%" prop="received_rmb" label="应收"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="income" label="利润"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="profit_rate" label="利润率"></el-table-column>
                            <!--
                            <el-table-column align="center" min-width="6%" prop="clients" label="客户名称"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="remark" label="备注"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="create_user" label="业务员"></el-table-column>
                            
                            <el-table-column align="center" min-width="10%" prop="caozuo" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                        @click="selectSavaList(scope.row)" >修改</el-button>
                                </template>
                            </el-table-column>
                            -->
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    const cityOptions = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-N', 'O-Z', '<M'];
    export default {
        data() {
            return {
                isAble: true,
                user:'admin',
                checkboxGroup1: [],
                checkboxGroup2: [],
                checkboxGroup3: [],
                checkboxGroup4: [],
                checkboxGroup5: [],
                checkboxGroup6: [],
                checkboxGroup7: [],
                checkboxGroup8: [],
                checkboxGroup9: [],
                checkboxGroup10: [],
                checkboxGroup11: [],
                checkboxGroup12: [],
                shapeList1: [{'value':'round'},{'value':'princess'},{'value':'radiant'}
                            ,{'value':'asscher'},{'value':'marquise'},{'value':'oval'}
                            ,{'value':'emerald'},{'value':'pear'},{'value':'heart'}
                            ,{'value':'cushion'},{'value':'others'},{'value':'triangle'}],
                shapeList: [{'value':'圆形'},{'value':'公主方'},{'value':'雷迪恩'}
                            ,{'value':'阿斯切'},{'value':'马眼'},{'value':'椭圆形'}
                            ,{'value':'祖母绿'},{'value':'梨形'},{'value':'心形'}
                            ,{'value':'垫形'},{'value':'其他'},{'value':'三角形'}],
                colList: [{'value':'D'},{'value':'E'},{'value':'F'}
                            ,{'value':'G'},{'value':'H'},{'value':'I'}
                            ,{'value':'J'},{'value':'K'},{'value':'L'}
                            ,{'value':'M-N'},{'value':'O-Z'}],
                claList: [{'value':'FL'},{'value':'IF'},{'value':'VVS1'}
                            ,{'value':'VVS2'},{'value':'VS1'},{'value':'VS2'}
                            ,{'value':'SI1'},{'value':'SI2'},{'value':'SI3'}
                            ,{'value':'I1'},{'value':'I2'}],
                cutList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'},{'value':'NN'}],
                polList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'}],
                flList: [{'value':'N'},{'value':'VSL'},{'value':'F'}
                            ,{'value':'M'},{'value':'S'},{'value':'VS'}],
                placeList: [{'value':'HK'},{'value':'SZ'},{'value':'CH'}
                            ,{'value':'INDIA'},{'value':'SH'},{'value':'H-K'}],
                certList: [{'value':'GIA'},{'value':'NGTC'},{'value':'IGI'}
                            ,{'value':'HRD'},{'value':'None'},{'value':'Other'}],
                inv_statusList: [{'value':'在库'},{'value':'不在库'}],
                sale_statusList: [{'value':'在售'},{'value':'保留'},{'value':'借货'}
                            ,{'value':'全款借货'},{'value':'确认销售'},{'value':'已完成'},{'value':'参考'},{'value':'藏'},{'value':'不在库'}],
                colorlist: cityOptions,
                clalist: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3','I1','I2'],
                cutlist: ['EX', 'VG', 'GD', 'FR', 'PR', 'NN'],
                pollist: ['EX', 'VG', 'GD', 'FR', 'PR'],
                fllist: ['N', 'VSL', 'F', 'M', 'S', 'VS'],
                certlist: ['GIA', 'NGTC', 'IGI'],
                isq: '',
                inv_status: '',
                addDataForm: {},
                addDataForm3: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                financialInfoList: [],
                financialInfoAllList: [],
                diamondInfoList: [],
                data_len: 0,
                ct_total: 0,
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                cost_total: 0,
                income_total: 0,
                profit_rate_total: 0,
                column: 'sale_price',
                order: 'asc',
                // 查询
                query: {
                    deal_date: [this.geFirstTime(),this.getEndTime()],
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    danhao: '1',
                    huiyuan: '1'
                },
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 50,
                    total: 0
                },
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectList();
            },
            // shape 形状
            checkboxChange1(val) {
                this.query.shape = val.join();
                console.log(this.query.shape);
            },
            // 颜色
            checkboxChange2(val) {
                this.query.col = val.join();
                console.log(this.query.col);
            },
            // 净度
            checkboxChange3(val) {
                this.query.cla = val.join();
                console.log(this.query.col);
            },
            // 切工
            checkboxChange4(val) {
                this.query.cut = val.join();
                console.log(this.query.cut);
            },
            // 抛光
            checkboxChange5(val) {
                this.query.pol = val.join();
                console.log(this.query.pol);
            },
            // 对称
            checkboxChange6(val) {
                this.query.sym = val.join();
                console.log(this.query.sym);
            },
            // 荧光
            checkboxChange7(val) {
                this.query.fl = val.join();
                console.log(this.query.fl);
            },
            // 证书
            checkboxChange8(val) {
                this.query.cert = val.join();
                console.log(this.query.cert);
            },
            // 销售状态
            checkboxChange9(val) {
                this.query.sale_status = val.join();
                console.log(this.query.sale_status);
            },
            // 库存状态
            checkboxChange11(val) {
                this.query.inv_status = val.join();
                console.log(this.query.inv_status);
            },
            // 地点
            checkboxChange12(val) {
                this.query.place = val.join();
                console.log(this.query.place);
            },
            // 联动赋值重量
            ctChange(val) {
                if(val == 3) {
                    this.$set(this.query,'ct1','0.30');
                    this.$set(this.query,'ct2','0.39');
                }else if(val == 4) {
                    this.$set(this.query,'ct1','0.40');
                    this.$set(this.query,'ct2','0.49');
                }else if(val == 5) {
                    this.$set(this.query,'ct1','0.50');
                    this.$set(this.query,'ct2','0.59');
                }else if(val == 6) {
                    this.$set(this.query,'ct1','0.60');
                    this.$set(this.query,'ct2','0.69');
                }else if(val == 7) {
                    this.$set(this.query,'ct1','0.70');
                    this.$set(this.query,'ct2','0.79');
                }else if(val == 8) {
                    this.$set(this.query,'ct1','0.80');
                    this.$set(this.query,'ct2','0.89');
                }else if(val == 9) {
                    this.$set(this.query,'ct1','0.90');
                    this.$set(this.query,'ct2','0.99');
                }else if(val == 10) {
                    this.$set(this.query,'ct1','1.00');
                    this.$set(this.query,'ct2','1.09');
                }else if(val == 11) {
                    this.$set(this.query,'ct1','1.10');
                    this.$set(this.query,'ct2','1.49');
                }else if(val == 12) {
                    this.$set(this.query,'ct1','1.50');
                    this.$set(this.query,'ct2','1.99');
                }else if(val == 13) {
                    this.$set(this.query,'ct1','2.00');
                    this.$set(this.query,'ct2','2.99');
                }else if(val == 14) {
                    this.$set(this.query,'ct1','3.00');
                    this.$set(this.query,'ct2','3.99');
                }else if(val == 15) {
                    this.$set(this.query,'ct1','4.00');
                    this.$set(this.query,'ct2','4.99');
                }else if(val == 16) {
                    this.$set(this.query,'ct1','5.00');
                    this.$set(this.query,'ct2','9.99');
                }
            },
            // 手动输入重量
            ctSelect(e) {
                let value = e.target.value;
                if(value) {
                    console.log(value)
                    if(value.includes('-')){
                        this.$nextTick(()=> {
                            this.$set(this.query,'ct',value);
                        })
                        // this.query.ct = value;
                        let valArr = value.split('-');
                        this.$set(this.query,'ct1',valArr[0]);
                        this.$set(this.query,'ct2',valArr[1]);
                        console.log(this.query.ct1);
                        console.log(this.query.ct2);
                    }
                }
            },
            // 手动输入重量2
            ctChange3(value) {
                if(value) {
                    this.$set(this.query,'ct','');
                    console.log(value)
                    this.$set(this.query,'ct1',value);
                    console.log(this.query.ct1);
                }
            },
            ctChange4(value) {
                if(value) {
                    console.log(value)
                    this.$set(this.query,'ct2',value);
                    console.log(this.query.ct2);
                }
            },
            // 3EXN
            select3exn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX'];
                this.checkboxGroup6 = ['EX'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX';
                this.query.sym = 'EX';
                this.query.fl = 'N';
            },
            // 3vg
            select3vgn() {
                this.checkboxGroup4 = ['EX','VG'];
                this.checkboxGroup5 = ['EX','VG'];
                this.checkboxGroup6 = ['EX','VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // 3gd
            select3gdn() {
                this.checkboxGroup4 = ['EX','VG','GD'];
                this.checkboxGroup5 = ['EX','VG','GD'];
                this.checkboxGroup6 = ['EX','VG','GD'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG,GD';
                this.query.pol = 'EX,VG,GD';
                this.query.sym = 'EX,VG,GD';
                this.query.fl = 'N';
            },
            selectChange1(el){
                if(el.target.tagName === 'INPUT') {
                    return;
                }
                this.isdisabled = false;
            },
            selectChange2(el){
                if(el.target.tagName === 'INPUT') {
                    return;
                }
                this.isdisabled = true;
            },

            // 选择器选择数据，加工数据证书号、统计数据
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 计算总销售额
                let sale_rap1 = 0;
                let sale_usd1 = 0;
                let sale_price1 = 0;
                let received_rmb1 = 0;
                let cost = 0;
                let ct1 = 0;
                for(let a = 0; a < this.data_len; a++) {
                    console.log(val[0].sale_price);
                    console.log(val[0].ct);
                    // 进货价
                    sale_rap1 += val[a].sale_rap;
                    // 销售价格
                    sale_usd1 += val[a].sale_usd;
                    sale_price1 += val[a].sale_price;
                    // 实收RMB
                    received_rmb1 += val[a].received_rmb;
                    // 成本
                    cost += val[a].rmb_cost;
                    // 重量
                    ct1 += parseFloat(val[a].ct);
                }
                // 进货价
                this.sale_rap_total = Math.round(sale_rap1);
                // 销售价格
                this.sale_usd_total = Math.round(sale_usd1);
                this.sale_price_total = Math.round(received_rmb1);
                // 成本
                this.cost_total = Math.round(cost);
                // 利润
                this.income_total = Math.round(received_rmb1 - cost);
                // 利润率
                this.profit_rate_total = ((received_rmb1 - cost) / cost * 100).toFixed(2);
                if(cost == 0){
                    this.profit_rate_total = 0;
                }
                // 总重量
                this.ct_total = ct1.toFixed(2);
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                this.dataOnLineListSelections.forEach(item =>{this.$set(item,'beilv',1)})
                this.dataOnLineListSelections.forEach(item =>{this.$set(item,'paid',item.received_rmb)})
                //console.log(this.dataOnLineListSelections)
                // 复制选中数据给客户
                /*
                for(let i =0;i<this.data_len;i++){
                    console.log(val[i]);
                }*/
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                this.sale_priceList = val.map((item) => item.sale_price);
                //数据选中后，显示按钮
                if(this.certnoList.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                // this.dialogTableVisible = true;
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 删除数据
            savaDataParams5() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/order/deleteOrdersInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 修改订单数据
            savaDataParams() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/order/savaOrdersInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            stock_id: _this.addDataForm.stock_id,
                            cert_no: _this.addDataForm.cert_no,
                            id: _this.addDataForm.id,

                            rate: _this.addDataForm.rate,
                            back: _this.addDataForm.back,
                            status: _this.addDataForm.status,
                            received_type: _this.addDataForm.received_type,
                            price: _this.addDataForm.price,
                            received: _this.addDataForm.received,
                            remark: _this.addDataForm.remark
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('本次操作成功！');
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 前端处理 导出选中数据
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','客户名称','货品状态', '记账日期', '到账日期'
                            , '成本rap', '成本折扣', '货品成本', '综合费点', '美金成本', '人民币成本'
                            , '销售美金', '销售汇率', '售价', '实收', '利润', '应收利润率'
                            , '备注', '业务员', '数据日期']
                    const filterVal = ['cert_no','clients','diamond_status', 'account_date', 'arrived_date'
                            ,'cost_rap', 'cost_dis', 'cost', 'point', 'usd_cost', 'rmb_cost'
                            , 'sale_usd', 'sale_rate', 'sale_price', 'paid', 'income', 'profit_rate'
                            , 'remark' , 'create_user', 'data_date' ]
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '财务信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 导出全部数据
            exportAll() {
                this.selectAllList();
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','客户名称','货品状态', '记账日期', '到账日期'
                            , '成本rap', '成本折扣', '货品成本', '综合费点', '美金成本', '人民币成本'
                            , '销售美金', '销售汇率', '售价', '实收', '利润', '应收利润率'
                            , '备注', '业务员', '数据日期']
                    const filterVal = ['cert_no','clients','diamond_status', 'account_date', 'arrived_date'
                            ,'cost_rap', 'cost_dis', 'cost', 'point', 'usd_cost', 'rmb_cost'
                            , 'sale_usd', 'sale_rate', 'sale_price', 'paid', 'income', 'profit_rate'
                            , 'remark' , 'create_user', 'data_date' ]
                    const list = this.financialInfoAllList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '全部财务信息')
                })
            },
            // 加载分页数据信息
            selectList() {
                let _this = this;
                util.publicget('/financial/queryProcureListPageModel', {
                    shape: _this.query.shape,
                    col: _this.query.col,
                    cla: _this.query.cla,
                    cut: _this.query.cut,
                    pol: _this.query.pol,
                    sym: _this.query.sym,
                    fl: _this.query.fl,
                    place: _this.query.place,
                    cert: _this.query.cert,
                    cert_no: _this.query.cert_no,
                    stock_id: _this.query.stock_id,
                    //sale_status: _this.query.sale_status,
                    sale_status: "已完成、参考",
                    inv_status: _this.query.inv_status,
                    greaterEqualsCt: _this.query.ct1,
                    lessEqualsCt: _this.query.ct2,
                    greaterEqualsMax_meas: _this.query.max_meas1,
                    lessEqualsMax_meas: _this.query.max_meas2,
                    greaterEqualsMin_meas: _this.query.min_meas1,
                    lessEqualsMin_meas: _this.query.min_meas2,
                    supplier: _this.query.supplier,
                    remark: _this.query.remark,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows,
                    order: _this.order,
                    greaterEqualsBuy_date: _this.query.buy_date == null ? '' : _this.query.buy_date[0],
                    lessEqualsBuy_date: _this.query.buy_date == null ? '' : _this.query.buy_date[1],
                    greaterEqualsDeal_date: _this.query.deal_date == null ? '' : _this.query.deal_date[0],
                    lessEqualsDeal_date: _this.query.deal_date == null ? '' : _this.query.deal_date[1],
                    greaterLirunlv: _this.query.lirunlv1,
                    lessEqualsLirunlv: _this.query.lirunlv2,
                    column: _this.column
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        if(res.count < _this.pager.rows){
                            _this.pager.page = 1;
                        }
                        _this.diamondInfoList = res.obj;
                        _this.certnoList = res.obj.map((item) => item.cert_no + '\n');
                        _this.idList = res.obj.map((item) => item.id);
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 加载信息分页列表
            selectList1() {
                let _this = this;
                util.publicget('/financial/queryFinancialInfoListPageModel', {
                    // cert_no: '203652.36',
                    cert_no: _this.query.cert_no,
                    equalsClients: _this.query.clients,
                    greaterEqualsAccount_date: _this.query.account_date == null ? '' : _this.query.account_date[0],
                    lessEqualsAccount_date: _this.query.account_date == null ? '' : _this.query.account_date[1],
                    greaterEqualsArrived_date: _this.query.arrived_date == null ? '' : _this.query.arrived_date[0],
                    lessEqualsArrived_date: _this.query.arrived_date == null ? '' : _this.query.arrived_date[1],
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.financialInfoList = res.obj;  
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 加载查询订单单条记录
            selectSavaList(rows) {
                let _this = this;
                util.publicget('/financial/queryFinancialList', {
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 加载查询订单全部记录
            selectAllList(rows) {
                let _this = this;
                util.publicget('/financial/queryFinancialList', {}, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        _this.financialInfoAllList = res.obj;
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 根据rmb排序
            sortTableFun (column) {
                this.column = column.prop;
                if (column.prop) {
                    if (column.order == 'ascending') {
                        this.order = 'asc'
                    }else if (column.order == 'descending') {
                        this.order = 'desc'
                    }
                    this.selectDiamondInfoList();
                }
            },
            renderHeader (h, {column, $index }) {
                if (column.order == 'ascending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-up'
                            })
                        ]
                    )
                }else if (column.order == 'descending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-down'
                            })
                        ]
                    )
                } else {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort'
                            })
                        ]
                    )
                }
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.checkboxGroup1 = [];
                this.checkboxGroup2 = [];
                this.checkboxGroup3 = [];
                this.checkboxGroup4 = [];
                this.checkboxGroup5 = [];
                this.checkboxGroup6 = [];
                this.checkboxGroup7 = [];
                this.checkboxGroup8 = [];
                this.checkboxGroup9 = [];
                this.checkboxGroup11= [];
                this.checkboxGroup12 = [];
                this.query = [];
                this.$set(this.pager,'page','1');
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.deal_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            geFirstTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                //date = date.toString().padStart(2, '0');
                date = '01';
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            getEndTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 2;
                month = month.toString().padStart(2, '0');
                //date = date.toString().padStart(2, '0');
                date = '01';
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            }
        },
        mounted() {
            this.selectList();
        }
    };
</script>

<style lang="scss" scoped>
    /**奇偶行变色 */
    .el-table__row--striped td {
        background-color: #eaf3fb !important;
    }
    /** 修改表格行高 */
    .el-table .el-table__cell{
        padding: 3px 0px
    }
    /**修改排序图标位置 */
    .el-table .cell {
        position:relative;
    }
    /*.el-table .caret-wrapper {
        position: absolute;
        right: -8px;
        top:50%;
        transform: translateY(-50%);
    }*/
    .el-icon-round {
        background:url('../../assets/images/cut/round.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-princess {
        background:url('../../assets/images/cut/princess.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-radiant {
        background:url('../../assets/images/cut/radiant.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-asscher {
        background:url('../../assets/images/cut/asscher.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-marquise {
        background:url('../../assets/images/cut/marquise.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-oval {
        background:url('../../assets/images/cut/oval.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-emerald {
        background:url('../../assets/images/cut/emerald.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-pear1 {
        background:url('../../assets/images/cut/pear1.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-heart {
        background:url('../../assets/images/cut/heart.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-cushion {
        background:url('../../assets/images/cut/cushion.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-others {
        background:url('../../assets/images/cut/others.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-triangle {
        background:url('../../assets/images/cut/triangle.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-dialog{
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/financial/financialInfoList.vue